var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 3.375H17.75C18.3477 3.375 18.875 3.90234 18.875 4.5C18.875 5.13281 18.3477 5.625 17.75 5.625H4.8125C4.49609 5.625 4.25 5.90625 4.25 6.1875C4.25 6.50391 4.49609 6.75 4.8125 6.75H17.75C18.9805 6.75 20 7.76953 20 9V16.875C20 18.1406 18.9805 19.125 17.75 19.125H4.25C2.98438 19.125 2 18.1406 2 16.875V5.625C2 4.39453 2.98438 3.375 4.25 3.375ZM16.625 11.8125C15.9922 11.8125 15.5 12.3398 15.5 12.9375C15.5 13.5703 15.9922 14.0625 16.625 14.0625C17.2227 14.0625 17.75 13.5703 17.75 12.9375C17.75 12.3398 17.2227 11.8125 16.625 11.8125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default ForwardRef;